import React from 'react';
import './OnboardingProgress.scss';

export default function OnboardingProgress({ progress, label }) {
    if (!progress) return null;
    if (progress.status === 'no_onboarding') {
        return <span className="onboarding-progress-empty">{label}: Not started</span>;
    }
    const percent = progress.completionPercent;
    if (typeof percent !== 'number' || !Number.isFinite(percent) || percent < 0 || percent > 100) return null;
    let url;
    try {
        url = new URL(progress.onboardingUrl);
        if (url.origin !== 'https://client-portal.mediatropy.com') return null;
    } catch { return null; }
    return (
        <a className="onboarding-progress" href={url.href} target="_blank" rel="noopener noreferrer"
            onClick={event => event.stopPropagation()}
            title={`${progress.completedSteps} of ${progress.totalSteps} steps complete. Open onboarding in Client Platform`}>
            <span className="onboarding-progress-label">{label} <strong>{percent}%</strong></span>
            <span className="onboarding-progress-track" role="progressbar" aria-label={label}
                aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent}>
                <span style={{ width: `${percent}%` }} />
            </span>
        </a>
    );
}
